import clsx from "clsx";
import { JSX, PropsWithChildren } from "react";
import styles from "./Button.module.scss";

export enum ButtonLayout {
  Primary = "primary",
  Unstyled = "unstyled",
}

type ButtonProps = PropsWithChildren<{
  layout?: ButtonLayout;
  buttonProps?: JSX.IntrinsicElements["button"];
}>;

const Button = ({
  layout = ButtonLayout.Primary,
  buttonProps,
  children,
}: ButtonProps) => {
  return (
    <button
      type="button"
      {...buttonProps}
      disabled={buttonProps?.disabled}
      className={clsx(buttonProps?.className, styles.btn, styles[layout], {
        [styles.disabled]: buttonProps?.disabled,
      })}
    >
      {children}
    </button>
  );
};

export default Button;
